import React from "react";
import { useNavigate } from "react-router-dom";
import { Home, RefreshCcw, AlertTriangle } from "lucide-react";
import "../customCSS/ErrorPage.css";

interface ErrorPageProps {
    title?: string;
    message?: string;
    onRetry?: () => void;
}

const ErrorPage: React.FC<ErrorPageProps> = ({
    title = "Oops! Something went wrong",
    message = "We're sorry for the inconvenience. Our team has been notified and we're working to fix it.",
    onRetry,
}) => {
    const navigate = useNavigate();

    return (
        <div className="error-page-wrapper">
            <div className="error-content">
                <div className="error-icon-wrapper">
                    <AlertTriangle size={64} className="error-icon" />
                    <div className="error-icon-pulse"></div>
                </div>

                <h1 className="error-title">{title}</h1>
                <p className="error-message">{message}</p>

                <div className="error-actions">
                    <button
                        className="error-btn primary"
                        onClick={() => (window.location.href = "/")}
                    >
                        <Home size={20} />
                        <span>Back to Home</span>
                    </button>

                    {onRetry && (
                        <button className="error-btn secondary" onClick={onRetry}>
                            <RefreshCcw size={20} />
                            <span>Try Again</span>
                        </button>
                    )}
                </div>

                <div className="error-footer">
                    <p>Need help? <a href="mailto:support@pksoft.com">Contact Support</a></p>
                </div>
            </div>

            <div className="error-background-shapes">
                <div className="shape shape-1"></div>
                <div className="shape shape-2"></div>
                <div className="shape shape-3"></div>
            </div>
        </div>
    );
};

export default ErrorPage;
